import z from "zod";

export const videoRecorderStartFormSchema = z.object({
	type: z.enum(["screen", "screen-camera", "screen-silent", "camera"]).default("screen"),
});

export type VideoRecorderStartFormSchema = z.infer<typeof videoRecorderStartFormSchema>;
